import { Component, OnInit } from '@angular/core';
import {AppDataService} from "../../../../services/AppDataService";
import {ModelToolsProvider} from "../../../../../framework/providers/model-tools/model-tools";

@Component({
  selector: 'app-menu-nav',
  templateUrl: './menu-nav.component.html',
  styleUrls: ['./menu-nav.component.scss'],
})
export class MenuNavComponent implements OnInit {

  public models;

  constructor(public appDataService:AppDataService, public tools:ModelToolsProvider) { }

  ngOnInit() {
    let data = this.appDataService.getModelsByKey('topSections', 'section');
    this.models = data['models'];
  }

  goTo(page, params = {})
  {
    this.tools.goTo(page, params);
  }

}

